import Tasks from 'components/Content/GameDetails/Tasks/Tasks';

export default Tasks;
